import * as React from 'react';
import { ClassName } from '../../utils/utils';

interface IBlockProps {
    type?: string;
    w?: number;
    h?: number;
    mb?: number;
    mr?: number;
    mt?: number;
    children?: any;
}

const Block = (props: IBlockProps) => {
    const { type, w, h, mb, mr, mt, children } = props;

    return (
        <div 
            className={ClassName('placeholder__block', [type])}
            style={{
                width: w,
                height: h,
                marginBottom: mb,
                marginTop: mt,
                marginRight: mr,
            }}
        >
            {children}
        </div>
    );
};

export default Block;


// WEBPACK FOOTER //
// ./src/modules/Placeholder/Block.tsx